import { APP_INITIALIZER, Injector } from '@angular/core';
import { combineLatest } from 'rxjs';
import { RoutesService } from '@abp/ng.core';
import { INCIDENTS_MANAGEMENT_ROUTE_VISIBILITY } from './features.token';
import { ProviderConsts } from 'src/app/shared/Constants/providers.constants';

export const INCIDENTS_MANAGEMENT_VISIBLE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: documentsManagementVisibility,
        deps: [Injector],
        multi: true,
    },
];

export function documentsManagementVisibility(injector: Injector) {
    return () => {
        const isIncidentsManagementFeatureEnable$ = injector.get(INCIDENTS_MANAGEMENT_ROUTE_VISIBILITY);
        const routes = injector.get(RoutesService);
        combineLatest([isIncidentsManagementFeatureEnable$]).subscribe(
        ([isIncidentsManagementFeatureEnable]) => {
            routes.patch(ProviderConsts.INCIDENT_ROUTE_PATCH_NAME, {
            invisible: !isIncidentsManagementFeatureEnable,
            });
        },
        );
    };
}
